import { useState, useEffect } from "react";

/*
 * Validates that a form input is filled out if it has been marked as required.
 */
export function useRequiredValidation<T>(isRequired: boolean, formValue: T) {
  const [validations, setValidations] = useState<string[]>([]);
  const [isFieldFilled, setIsFieldFilled] = useState(false);

  const onInvalid = () => {
    if (isRequired && formValue === "") {
      setValidations(["This field is required"]);
    } else {
      setValidations([]);
    }
  };

  useEffect(() => {
    setIsFieldFilled(formValue !== "");
  }, [formValue]);

  return {
    validations,
    setValidations,
    onInvalid,
    isFieldFilled
  };
}
